import React from "react";
import { FiInbox } from "react-icons/fi";

/**
 * Consistent empty state for tables/lists.
 */
export default function EmptyState({ icon: Icon = FiInbox, title = "Belum ada data", description, action, className = "" }) {
    return (
        <div className={`flex flex-col items-center justify-center px-6 py-14 text-center ${className}`}>
            <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500">
                <Icon className="h-6 w-6" />
            </div>
            <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-200">{title}</h3>
            {description && (
                <p className="mt-1 max-w-sm text-sm text-slate-500 dark:text-slate-400">{description}</p>
            )}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
}
